var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusCircleWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C4.41602 2 1.5 4.91602 1.5 8.5C1.5 12.084 4.41602 15 8 15C11.584 15 14.5 12.084 14.5 8.5C14.5 4.91602 11.584 2 8 2ZM8 3C11.043 3 13.5 5.45703 13.5 8.5C13.5 11.543 11.043 14 8 14C4.95703 14 2.5 11.543 2.5 8.5C2.5 5.45703 4.95703 3 8 3ZM7.5 5.5V8H5V9H7.5V11.5H8.5V9H11V8H8.5V5.5H7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleWhiteIcon);
export default __webpack_public_path__ + "static/media/plusCircleWhiteIcon.907e97660fffa15228c079c02105e326.svg";
export { ForwardRef as ReactComponent };